import { useTranslation } from "react-i18next";
import Table from "../components/global/Table";
import Text from "../components/ingka/Text";
import Load from "../components/ingka/Load";
import iconGo from '@ingka/ssr-icon/paths/arrow-right'
import Button from "../components/ingka/Button";
import { useNavigate } from "react-router-dom";
import { useSessionStore } from "../store/sessionStore";
import { useMotions } from "../hooks/use-motions";

const CellState = (data) => <span style={{color: data.row.original.state.id === 1 ? "rgb(204, 0, 8)" : "rgb(10, 138, 0)"}}>
          <b>{data.row.original.state.value}</b>
        </span>

export default function YourMotions() {
  const [t] = useTranslation("global")
  const navigate = useNavigate()
  const { setMotion } = useSessionStore()
  const { motions, totalElements, totalPages, isLoading, goto } = useMotions()

  const columns = [
    {
      accessorKey: "creationDate", 
      header: t('global.date'),
    },
    {
      accessorKey: "name", 
      header: t('yourMotions.motionIn'),
    },
    {
      accessorKey: "trackingTime",
      header: t('global.time'),
    },
    {
      accessorKey: "state.value",
      header: t('global.state'),
      Cell: CellState
    }
  ]

  const goToMotion = (mot) => {
    const motion = {
      level: mot.level,
      map: mot.map,
      ...(mot.section ? {section: mot.section} : {}),
      ...(mot.subsection ? {subsection: mot.subsection} : {})
    }
    setMotion(motion)
    navigate(`/motion/${mot.id}`)
  }

  if(isLoading) return <Load />

  return (
    <div>
      <Text tagName="h2" headingSize="m">{t('yourMotions.title')}</Text>
        <Table 
          columns={columns} 
          data={motions}
          short={{id:'creationDate', desc: true}}
          enableRowActions={true}
          enablePagination={true}
          pageChange={(pageIndex) => goto(pageIndex)}
          pageInfo={{rowCount: totalElements, pageCount: totalPages}}
          renderRowActions= {({ row }) => {
            if(row.original.state.id === 1){//is draft
              return(
                <Button
                  type="tertiary"
                  small
                  iconOnly
                  ssrIcon={iconGo}
                  onClick={() => goToMotion(row.original)}
                />
              )
            }
          }}
        />
    </div>
  )
}
